import { ReactNode } from 'react';

export interface SkeletonProps {
  className?: string;
  children?: ReactNode;
  variant?: 'text' | 'circular' | 'rectangular';
  width?: string | number;
  height?: string | number;
}

export function Skeleton({ className = '', variant = 'text', width, height, children }: SkeletonProps) {
  const baseStyles = 'animate-pulse bg-slate-200 dark:bg-slate-700 rounded';
  
  const variantStyles = {
    text: 'h-4',
    circular: 'rounded-full',
    rectangular: 'rounded-lg',
  };

  const style: React.CSSProperties = {
    width: width ? (typeof width === 'number' ? `${width}px` : width) : undefined,
    height: height ? (typeof height === 'number' ? `${height}px` : height) : undefined,
  };

  if (children) {
    return (
      <div className={`${baseStyles} ${variantStyles[variant]} ${className}`} style={style}>
        {children}
      </div>
    );
  }

  return <div className={`${baseStyles} ${variantStyles[variant]} ${className}`} style={style} />;
}